'use client';
import styled from 'styled-components';
import { theme } from 'styles/theme';

const Next = ({classCustom, hoverColor, id}) => {
    return (
        <StyledHamNext hoverColor={hoverColor} className={`menu-hamburger ${classCustom ? classCustom : ''}`} id={`${id ? id : 'next-button'}`}>
            <svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle opacity="0.5" cx="21" cy="21" r="20" transform="rotate(-90 21 21)" stroke="white" />
                <circle className={'hover-circle'} opacity="0.5" cx="21" cy="21" r="0" transform="rotate(-90 21 21)" fill="#5D8D3B" />
                <path d="M13 21L29 21" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M23 27L29 21L23 15" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        </StyledHamNext>
    );
};
const StyledHamNext = styled.div`
    cursor: pointer;
    transition: ${theme.transition};
    height: 40px;
    width: 40px;
    display: inline-block;

    svg {
        height: 40px;
        width: 40px;

        path {
            transition: ${theme.transition};

        }

        circle {
            transition: ${theme.transition};
        }
    }

    &:hover {
        svg {
            .hover-circle{
                r:20px;
            }
            path {
                transform: translateX(2px);
            }
        }
    }

`
export default Next;